<template>
   <div>
       <app-header>
           <template slot="title">Mein Konto</template>
       </app-header>
       <div class="container" >
           <div class="row" id="top">
               <div class="col-8">
                   <div class="font-title-normal">Aktuelles Guthaben</div>
                   <div class="font-title-normal">CHF 9542.50</div>
                   <div class="font-tiny">Aktualisiert am 18 Juni 2018</div>
               </div>
               <div class="col-4">
                   <img src="./../assets/images/konto-img.png" alt="">
               </div>
           </div>
           <router-link to="/konto_auszahlen">
               <div class="row" id="middle">
                   <div class="font-normal col-10 btn-base">Guthaben auszahlen</div>
                   <div class="img-next col-2">
                       <img src="./../assets/images/next.svg" alt="">
                   </div>
               </div>
           </router-link>

           <div class="row" id="list">
               <div class="col-1 list-top">
                   <img src="./../assets/images/konto-icon.svg">
               </div>
               <div class="col-11 list-top">
                   <div class="font-btn-small"> Transaktionen Verlauf</div>
               </div>
               <div class="col-1 list-body">
                   <div id="purple-line"></div>
               </div>
               <div class="col-11 list-body">
                   <app-list-konto></app-list-konto>
               </div>
           </div>
       </div>
       <app-nav></app-nav>
   </div>
</template>

<script>
  import Header from './../components/Header'
  import Nav from './../components/Nav'
  import ListKonto from './../components/konto/ListKonto'
    export default {
      components: {
        appHeader: Header,
        appNav: Nav,
        appListKonto: ListKonto
      }
    }
</script>

<style lang="scss" scoped>
    @import './../styles/app';
    .row {
        padding: 18px;
        border-bottom: 1px solid $color-list-border;
    }
    #top {

        .font-tile-normal:nth-of-type(2) {
            font-weight: bold;
        }
        img {
            float: right;
        }
    }

    #middle {
        .font-normal {
            color: $color-secondary;
            font-weight: bold;
        }
        .img-next {
            text-align: right;
            line-height: 24px;
            img {
                vertical-align: middle;
            }
        }
    }
    #list {
        height: 100%;
        margin-top: 7px;
        .list-top {
            margin-bottom: 10px;
            & .font-btn-small {
                padding-left: 0;
            }
        }
        #purple-line {
            margin-left: 5px;
            height: 100%;
            border-left: 2px solid $color-primary;
        }
    }
</style>
